import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import ElectricalSidebar from './ElectricalSidebar';
import ht1 from '../../img/HT Switchgear/ht1.jpg';
import ht3 from '../../img/HT Switchgear/ht3.jpg'

function HTSwitchgear() {
  useEffect(() => {
    AOS.init({ duration: 800 });
  }, []);

  return (
    <section className="py-5 bg-light mt-5" id="power-distribution-board">
      <div className="container">
        <div className="row">
          {/* Main Content */}
          <div className="col-lg-9 col-md-8 mb-4">
            {/* Title */}
            <div className="text-center mb-4" data-aos="fade-up">
              <h2 className="fw-bold">HT Switchgear</h2>
              <p className="text-muted">
                Managing and distributing electrical power safely and efficiently across facilities.
              </p>
            </div>

            {/* Intro */}
            <div className="mb-4" data-aos="fade-up">
              <p className="text-muted lead">
                HT switchgear is used for controlling, protecting, and isolating electrical equipment in medium and high-voltage networks. It is commonly installed in substations, power plants, industrial facilities, and utility grids to ensure safe operation and fault management.
              </p>
              <p className="text-muted fw-semibold">HT Switchgear &nbsp; | &nbsp; Power Distribution</p>
            </div>

            {/* Images */}
            <div className="row mb-4" data-aos="zoom-in">
              <div className="col-md-6 mb-3">
                <img
                  src={ht1}
                  alt="HT Switchgear"
                  className="img-fluid rounded shadow"
                  style={{ maxHeight: '240px', objectFit: 'cover', width: '100%' }}
                />
              </div>
              <div className="col-md-6 mb-3">
                <img
                  src={ht3}
                  alt="Electrical Switchgear Setup"
                  className="img-fluid rounded shadow"
                  style={{ maxHeight: '240px', objectFit: 'cover', width: '100%' }}
                />
              </div>
            </div>

            {/* Ratings */}
            <div className="mb-4" data-aos="fade-up">
              <h4 className="text-primary">📏 Ratings</h4>
              <ul className="text-muted">
                <li><strong>Voltage Class:</strong> 11kV to 132kV</li>
                <li><strong>Current Rating:</strong> Up to 3150A</li>
                <li><strong>Short Circuit Withstand:</strong> Up to 40kA for 1 sec</li>
                <li><strong>Insulation Type:</strong> Air-insulated (AIS) or SF₆-insulated</li>
              </ul>
            </div>

            {/* IEC Standards */}
            <div className="mb-4" data-aos="fade-up">
              <h4 className="text-info">📘 IEC Standards</h4>
              <ul className="text-muted">
                <li><strong>IEC 62271-200</strong> – Metal-enclosed switchgear</li>
              </ul>
            </div>

            {/* Key Features */}
            <div className="mb-4" data-aos="fade-up">
              <h4 className="text-success">✨ Key Features</h4>
              <ul className="text-muted">
                <li>Vacuum Circuit Breaker (VCB) up to 3150A</li>
                <li>Voltage rating: 11kV and 132kV</li>
                <li>Advanced protection relays (Overcurrent, Earth Fault, etc.)</li>
                <li>Metal-clad construction for arc-fault containment</li>
                <li>Remote operation and fault diagnostics (optional)</li>
              </ul>
            </div>

            {/* Components */}
            <div className="mb-4 p-4 bg-white border-start border-4 border-primary rounded" data-aos="fade-up">
              <h5 className="text-primary fw-semibold">🔧 Components</h5>
              <ul className="text-muted mb-0">
                <li>Main Breaker or Fuse</li>
                <li>Circuit Breakers or Fuses</li>
                <li>Busbars</li>
                <li>Neutral and Ground Bars</li>
                <li>Meters and Indicators</li>
                <li>Terminal Blocks</li>
                <li>Enclosure</li>
              </ul>
            </div>

            {/* Applications */}
            <div className="mb-4 p-4 bg-white border-start border-4 border-success rounded" data-aos="fade-up">
              <h5 className="text-success fw-semibold">🏢 Applications</h5>
              <ul className="text-muted mb-0">
                <li>Substations</li>
                <li>Power Plants</li>
                <li>Industrial Facilities</li>
                <li>Utility Grids</li>
                <li>Commercial Buildings</li>
              </ul>
            </div>
          </div>

          {/* Sidebar */}
          <ElectricalSidebar />
        </div>
      </div>
    </section>
  );
}

export default HTSwitchgear;
